import { Injectable } from '@angular/core';
import { TableDatasource } from '@core/api/table.datasource';
import { OpkraevningsListe } from './opkraevningsliste.model';
import { OpkraevningsListerSearchParams } from './opkraevningslister-search/opkraevningslister-search-params.model';
import { appConfig } from '@core/app-config';
import { OpkraevningsListeSummary } from './opkraevningsliste-summary.model';
import { GodkendAlleSummary } from './godkendalle-summary.model';

@Injectable({
  providedIn: 'root',
})
export class OpkraevningsListerDatasource extends TableDatasource<
  OpkraevningsListe,
  OpkraevningsListerSearchParams
> {
  endpoint = '/api/admin/opkraevningslister';
  defaultSortField = 'oprettelseDato';
  override defaultDescending = true;

  async getSummary(opkraevningsListeId: number, abortSignal?: AbortSignal) {
    const url = `${appConfig.apiRoot}${this.endpoint}/summary?opkraevningsListeId=${opkraevningsListeId}`;
    const options = await this.getOptions(abortSignal);
    return await this.fetchSingle<OpkraevningsListeSummary>(url, options);
  }

  async godkendAlle(opkraevningsListeId: number, abortSignal?: AbortSignal) {
    const url = `${appConfig.apiRoot}${this.endpoint}/godkendalle?opkraevningsListeId=${opkraevningsListeId}`;
    const options = await this.getOptions(abortSignal);
    options.method = 'POST';
    return await this.fetchSingle<GodkendAlleSummary>(url, options);
  }
  async afsendKoersel(opkraevningsListeId: number, abortSignal?: AbortSignal) {
    const url = `${appConfig.apiRoot}${this.endpoint}/afsendkoersel?opkraevningsListeId=${opkraevningsListeId}`;
    const options = await this.getOptions(abortSignal);
    options.method = 'POST';
    const updatedListe = await this.fetchSingle<OpkraevningsListe>(
      url,
      options
    );
    this.updateLocalData(updatedListe);
    return updatedListe;
  }
}
